module.exports = __webpack_public_path__ + "img/nonedata.e12f8e8d.png";